<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="编辑"
    width="500px"
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px">

        <el-form-item label="形象图片" prop="img_dispaly">
            <el-upload
              class="upload"
              :action="uploadFileUrl"
              :on-remove="(files) => handleRemove(files)"
              :on-success="(response, files) => uploadFileSuccess(response, files)"
              :on-error="uploadFileError"
              :file-list="formData.photoFiles"
              list-type="picture-card"
              >
                <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
      
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>


  </el-dialog>
</template>

<script>
import { recommendupdate } from "@/api/user/index.js";
import urlConfig from '@/api/config'

export default {
  components: { },

  data() {
    return {
      visible: false,
      uploadFileUrl:  urlConfig.prod.baseURL +"/web/file/Upload", // 上传的图片服务器地址
      
      formData: {
        img_dispaly:[],//
        photoFiles:[],
      },
       rules: {
        img_dispaly: [
              {required: true, message: '请选择形象图片', trigger: 'change'}
          ],
       }
    };
  },

  mounted() {
    console.log("asdasdasd")

},
  
  methods: {
    handleClose() {
      this.visible = false;
      this.$refs["form"].resetFields();

    },


    init(img_dispaly) {
      var that=this;
      if(!img_dispaly){
        img_dispaly=[];
      }
      this.formData.img_dispaly=img_dispaly;
    
      
      var photoFiles=[];
      for (let item of that.formData.img_dispaly) {
        var file={
          name:"1111", url:item,
        }
          photoFiles.push(file);
      }
        that.formData.photoFiles=photoFiles;

      this.visible = true;
    },


   

    // 上传失败
    uploadFileError(err) {
      this.$message.error("上传失败, 请重试");
    },

    // 删除文件
    handleRemove(files) {
      console.log(files)
      var index =  this.formData.photoFiles.indexOf(files)
      this.formData.photoFiles.splice(index, 1);
      this.formData.img_dispaly.splice(index, 1);
      console.log("this.formData.img_dispaly",this.formData.img_dispaly)
     
    },
  

     // 上传成功的钩子函数
     uploadFileSuccess(response, files) {
      console.log(response);
      if(response.code==1){
        var file={
          name:response.filename, url:response.file,
        }
        this.formData.photoFiles.push(file);
        this.formData.img_dispaly.push(response.file);
      }
      
    },
    
    
    submit(){
      var that=this;
      this.$refs["form"].validate((valid) => {
          if (valid) {
            recommendupdate(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'

                });
                that.$emit('refresh');
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });

    },

    
  },

 
};
</script>

<style lang="scss" scoped>



::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
